/** @internal */
export var commonEventListenerOptions = {
  // Passive means we promise not to call preventDefault. This provides some
  // optimizations.
  passive: true
};